import React from 'react';
export const CardImage = _ref => {
  let {
    imageUrl
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "card-image"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: "card-image__image",
    src: imageUrl
  }));
};